import {
  AppointmentStatusNotificationConfig,
  AppointmentUpdateNotificationConfig,
  ExportNotificationConfig,
  KeyLockerCallForHelpNotificationConfig,
  NewAppointmentNotificationConfig,
  PinStatusNotificationConfig
} from "components/NotificationsCenter/components/ClaireNotification/components";

import type { NotificationType } from "components/NotificationsCenter/hooks";
import type { Appointment, Pin } from "models";
import type { ReactNode } from "react";
import type { ToastOptions } from "react-toastify";

type NotificationRegistryProps = {
  icon: string;
  title: string;
  path?: string;
  pin?: Pin;
  appointment?: Appointment;
  description?: string;
};

export type NotificationRegistryConfig = {
  toastOptions: ToastOptions;
  render: (props: NotificationRegistryProps & { closeToast: () => void }) => ReactNode;
};

export const ClaireNotificationsRegistry: Record<NotificationType, NotificationRegistryConfig> = {
  AppointmentStatusNotification: AppointmentStatusNotificationConfig,
  AppointmentUpdateNotification: AppointmentUpdateNotificationConfig,
  ExportNotification: ExportNotificationConfig,
  KeyLockerCallForHelpNotification: KeyLockerCallForHelpNotificationConfig,
  NewAppointmentNotification: NewAppointmentNotificationConfig,
  PinStatusNotification: PinStatusNotificationConfig
};
